import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { sideMenu } from '../../../utils/staticData';
import axiosIns, { API_URL } from '../../../_config';

const SideBar = () => {
    const navigate = useNavigate();
    const activeItems = Number(sessionStorage.getItem("activeItems")) || 0;
    const [activeIndex, setActiveIndex] = useState(activeItems || 0);
    const subMenuActiveIndexSession = sessionStorage.getItem("subMenuActiveIndex");
    const initialSubMenuActiveIndex = subMenuActiveIndexSession !== null ? Number(subMenuActiveIndexSession) : null;
    const [subMenuActiveIndex, setSubMenuActiveIndex] = useState(initialSubMenuActiveIndex);
    const [data, setData] = useState([]);

    // Fetch All FAQs
    const fetchData = async () => {
        try {
            const res = await axiosIns.get(`${API_URL.getMenusWithRole}?roleId=1`);
            if (res?.data?.isSuccess === 1) {
                setData(res.data.data);
            }
        } catch (error) {
            setData([])
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (subMenuActiveIndexSession !== null) {
            setSubMenuActiveIndex(initialSubMenuActiveIndex);
        }
    }, [initialSubMenuActiveIndex, subMenuActiveIndexSession]);

    const toggleMenuToggle = (item, index) => {
        setActiveIndex(activeIndex === index ? null : index);
        if (activeItems !== index) {
            setSubMenuActiveIndex(null);
        }
        sessionStorage.setItem("activeItems", index);
        if (item?.type !== "collapsible") {
            sessionStorage.setItem("activeItemUrl", item?.url);
            navigate(item?.url);
        }
    };

    const onRedirectSubManu = (item, j) => {
        setSubMenuActiveIndex(j);
        sessionStorage.setItem("subMenuActiveIndex", j);
        sessionStorage.setItem("activeItemUrl", item?.url);
        navigate(item?.url);
    }

    return (
        <div className='admin_sidebar_main '>
            <div className='admin_sidebar_inner'>
                <div className='sidebar_logo_main my-3'>
                    <img src="/images/ishivaxlogo.png" alt='' />
                </div>
                <div className='sidebrar_content_main'>
                    {data?.length > 0 && (
                        <div className='sidebar_content_inner'>
                            {data?.map((item, i) => (
                                <div className='sidebar_content_item my-2' key={i}>
                                    <div onClick={() => toggleMenuToggle(item, i)} className={`sidebar_content_item_inner ${activeIndex === i ? 'active' : ''}`}>
                                        <div className='sidebar_content_item_inner_link'>
                                            <i className={item.icon}></i>
                                            <span>{item.title}</span>
                                        </div>
                                        {item?.type === "collapsible" && (
                                            <div className='sidebar_content_item_inner_link'>
                                                <svg className={`arrow mb-0 ${activeIndex === i ? 'rotate' : ''}`} width="15" height="12" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4 0.75L7.182 3.932L6.121 4.992L4 2.871L1.879 4.992L0.818 3.932L4 0.75Z" fill="#747684" />
                                                </svg>
                                            </div>
                                        )}
                                    </div>

                                    {item?.type === "collapsible" && activeIndex === i && (
                                        <div className="sidebar_content_item_inner_submenu">
                                            <ul>
                                                {item.children.map((subItem, j) => (
                                                    <li onClick={() => onRedirectSubManu(subItem, j)} className={`my-2 submenu_items ${subMenuActiveIndex === j ? 'activeSubmenu' : ''}`}>{subItem.title}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SideBar;
